import React from 'react';
import { Link } from 'react-router-dom';

const S = {
  wrap: { minHeight: '100vh', background: '#f4ede0', fontFamily: "'DM Sans', sans-serif" },
  header: { background: '#14562e', padding: '20px 0' },
  headerInner: { maxWidth: '900px', margin: '0 auto', padding: '0 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  back: { color: 'rgba(255,255,255,.7)', textDecoration: 'none', fontSize: '14px', fontWeight: 600 },
  content: { maxWidth: '900px', margin: '0 auto', padding: '48px 24px 80px' },
  h1: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 800, fontSize: '36px', color: '#14562e', margin: '0 0 8px', textTransform: 'uppercase' },
  updated: { fontSize: '13px', color: '#6a7268', marginBottom: '32px' },
  h2: { fontFamily: "'Bricolage Grotesque', sans-serif", fontWeight: 700, fontSize: '20px', color: '#14562e', margin: '32px 0 12px' },
  h3: { fontWeight: 700, fontSize: '16px', color: '#183d24', margin: '20px 0 8px' },
  p: { fontSize: '15px', lineHeight: 1.7, color: '#333', margin: '0 0 12px' },
  ul: { paddingLeft: '20px', margin: '0 0 12px' },
  li: { fontSize: '15px', lineHeight: 1.7, color: '#333', marginBottom: '6px' },
  highlight: { background: '#e6f0e9', padding: '16px 20px', borderRadius: '12px', borderLeft: '4px solid #14562e', margin: '16px 0' },
  footer: { background: '#14562e', padding: '24px', textAlign: 'center', color: 'rgba(255,255,255,.6)', fontSize: '13px' },
};

function PageWrapper({ children }) {
  return (
    <div style={S.wrap}>
      <div style={S.header}>
        <div style={S.headerInner}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/nico-1.png" alt="NICO" style={{ height: '32px', filter: 'brightness(0) invert(1)' }} />
          </Link>
          <Link to="/" style={S.back}>← Voltar ao site</Link>
        </div>
      </div>
      <div style={S.content}>{children}</div>
      <div style={S.footer}>
        © {new Date().getFullYear()} NICO — uma plataforma Lab2513 · usenico.com.br
      </div>
    </div>
  );
}

export function PrivacyPage() {
  return (
    <PageWrapper>
      <h1 style={S.h1}>Política de Privacidade</h1>
      <p style={S.updated}>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

      <div style={S.highlight}>
        <p style={{ ...S.p, margin: 0, fontWeight: 600 }}>A Lab2513 Tecnologia ("Lab2513"), responsável pela plataforma NICO, respeita a sua privacidade e se compromete a proteger os dados pessoais coletados, em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018).</p>
      </div>

      <h2 style={S.h2}>1. Dados que Coletamos</h2>

      <h3 style={S.h3}>1.1 Dados fornecidos por você</h3>
      <ul style={S.ul}>
        <li style={S.li}>Dados de cadastro: nome completo, e-mail, telefone, senha (armazenada com criptografia bcrypt)</li>
        <li style={S.li}>Dados de veículos: marca, modelo, ano, placa, quilometragem, cor</li>
        <li style={S.li}>Registros de serviços: tipo, data, custo, profissional responsável, observações</li>
        <li style={S.li}>Dados profissionais (para contas profissionais): nome da oficina, CNPJ/CPF, endereço, especialidade, WhatsApp</li>
      </ul>

      <h3 style={S.h3}>1.2 Dados coletados automaticamente</h3>
      <ul style={S.ul}>
        <li style={S.li}>Dados técnicos: endereço IP, tipo de navegador, sistema operacional, páginas acessadas</li>
        <li style={S.li}>Dados de uso: funcionalidades utilizadas, frequência de acesso, interações com a plataforma</li>
        <li style={S.li}>Cookies essenciais: para manter sua sessão ativa e preferências</li>
      </ul>

      <h3 style={S.h3}>1.3 Dados de terceiros</h3>
      <ul style={S.ul}>
        <li style={S.li}>Tabela FIPE: consultamos dados públicos de veículos para referência de valor e identificação (marca, modelo, ano). Esses dados são públicos e não pessoais</li>
      </ul>

      <h2 style={S.h2}>2. Finalidade do Tratamento</h2>
      <p style={S.p}>Utilizamos seus dados para:</p>
      <ul style={S.ul}>
        <li style={S.li}>Criar e manter sua conta na plataforma</li>
        <li style={S.li}>Gerenciar o histórico de manutenção dos seus veículos</li>
        <li style={S.li}>Permitir a validação de serviços por profissionais credenciados</li>
        <li style={S.li}>Gerar relatórios de histórico veicular para venda</li>
        <li style={S.li}>Enviar alertas de manutenção e notificações relevantes</li>
        <li style={S.li}>Conectar donos de veículos a profissionais verificados</li>
        <li style={S.li}>Melhorar a plataforma e desenvolver novas funcionalidades</li>
        <li style={S.li}>Cumprir obrigações legais e regulatórias</li>
      </ul>

      <h2 style={S.h2}>3. Base Legal (Art. 7º da LGPD)</h2>
      <ul style={S.ul}>
        <li style={S.li}><strong>Consentimento</strong> (art. 7º, I): ao criar sua conta, você consente com o tratamento dos dados para as finalidades descritas</li>
        <li style={S.li}><strong>Execução de contrato</strong> (art. 7º, V): para prestação dos serviços contratados</li>
        <li style={S.li}><strong>Legítimo interesse</strong> (art. 7º, IX): para melhorias na plataforma e comunicações relevantes</li>
        <li style={S.li}><strong>Cumprimento de obrigação legal</strong> (art. 7º, II): quando exigido por lei ou regulação</li>
      </ul>

      <h2 style={S.h2}>4. Compartilhamento de Dados</h2>
      <p style={S.p}>Seus dados podem ser compartilhados com:</p>
      <ul style={S.ul}>
        <li style={S.li}><strong>Profissionais da rede NICO:</strong> quando você solicita validação de um serviço, o profissional recebe apenas os dados necessários (veículo, serviço registrado)</li>
        <li style={S.li}><strong>Compradores de veículos:</strong> apenas quando você gera e compartilha voluntariamente um relatório de venda</li>
        <li style={S.li}><strong>Prestadores de serviços técnicos:</strong> infraestrutura de hospedagem (Cloudflare, Render, Supabase), envio de e-mails (Resend) — todos com políticas de privacidade próprias e adequação à LGPD ou equivalentes internacionais</li>
      </ul>
      <div style={S.highlight}>
        <p style={{ ...S.p, margin: 0 }}><strong>Nunca vendemos, alugamos ou compartilhamos seus dados pessoais com terceiros para fins de marketing ou publicidade.</strong></p>
      </div>

      <h2 style={S.h2}>5. Seus Direitos (Art. 18 da LGPD)</h2>
      <p style={S.p}>Você tem direito a:</p>
      <ul style={S.ul}>
        <li style={S.li}>Confirmar a existência de tratamento dos seus dados</li>
        <li style={S.li}>Acessar seus dados pessoais</li>
        <li style={S.li}>Corrigir dados incompletos, inexatos ou desatualizados</li>
        <li style={S.li}>Solicitar a anonimização, bloqueio ou eliminação de dados desnecessários</li>
        <li style={S.li}>Solicitar a portabilidade dos dados</li>
        <li style={S.li}>Revogar o consentimento a qualquer momento</li>
        <li style={S.li}>Solicitar a eliminação dos dados pessoais tratados com base no consentimento</li>
      </ul>
      <p style={S.p}>Para exercer qualquer desses direitos, envie um e-mail para <strong>privacidade@usenico.com.br</strong>. Responderemos em até 15 dias úteis.</p>

      <h2 style={S.h2}>6. Armazenamento e Segurança</h2>
      <ul style={S.ul}>
        <li style={S.li}>Senhas armazenadas com hash bcrypt (12 rounds) — nunca em texto puro</li>
        <li style={S.li}>Comunicação via HTTPS com certificado SSL/TLS</li>
        <li style={S.li}>Tokens de autenticação JWT com expiração</li>
        <li style={S.li}>Banco de dados com acesso restrito e backups regulares</li>
        <li style={S.li}>Dados armazenados em servidores com proteção adequada (Supabase/AWS)</li>
      </ul>

      <h2 style={S.h2}>7. Retenção de Dados</h2>
      <p style={S.p}>Seus dados são mantidos enquanto sua conta estiver ativa. Ao solicitar exclusão da conta, seus dados pessoais serão eliminados em até 30 dias, exceto quando houver obrigação legal de retenção. Registros de serviços validados podem ser mantidos de forma anonimizada para integridade do histórico veicular.</p>

      <h2 style={S.h2}>8. Cookies</h2>
      <p style={S.p}>Utilizamos apenas cookies essenciais para manter sua sessão ativa (token de autenticação). Não utilizamos cookies de rastreamento, analytics de terceiros ou publicidade.</p>

      <h2 style={S.h2}>9. Menores de Idade</h2>
      <p style={S.p}>A plataforma NICO é destinada a pessoas com 18 anos ou mais. Não coletamos intencionalmente dados de menores de 18 anos.</p>

      <h2 style={S.h2}>10. Alterações nesta Política</h2>
      <p style={S.p}>Esta política pode ser atualizada periodicamente. Alterações significativas serão comunicadas por e-mail ou notificação na plataforma. A continuidade do uso após alterações constitui aceitação.</p>

      <h2 style={S.h2}>11. Contato</h2>
      <p style={S.p}>Para dúvidas, solicitações ou reclamações sobre privacidade e proteção de dados:</p>
      <ul style={S.ul}>
        <li style={S.li}><strong>Controlador:</strong> Lab2513 Tecnologia</li>
        <li style={S.li}><strong>E-mail:</strong> privacidade@usenico.com.br</li>
        <li style={S.li}><strong>Plataforma:</strong> usenico.com.br</li>
      </ul>
    </PageWrapper>
  );
}

export function TermsPage() {
  return (
    <PageWrapper>
      <h1 style={S.h1}>Termos de Uso</h1>
      <p style={S.updated}>Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>

      <div style={S.highlight}>
        <p style={{ ...S.p, margin: 0, fontWeight: 600 }}>Ao utilizar a plataforma NICO (usenico.com.br), você concorda com estes Termos de Uso. A plataforma é operada pela Lab2513 Tecnologia ("Lab2513"). Leia com atenção antes de prosseguir.</p>
      </div>

      <h2 style={S.h2}>1. Definições</h2>
      <ul style={S.ul}>
        <li style={S.li}><strong>Plataforma:</strong> o sistema NICO, acessível via web em usenico.com.br e aplicativos móveis</li>
        <li style={S.li}><strong>Usuário Dono:</strong> pessoa física que cadastra e gerencia veículos próprios</li>
        <li style={S.li}><strong>Usuário Profissional:</strong> mecânico, oficina ou profissional automotivo cadastrado na rede NICO</li>
        <li style={S.li}><strong>Validação:</strong> ato pelo qual um Profissional confirma a realização de um serviço registrado</li>
        <li style={S.li}><strong>Relatório:</strong> documento gerado pela plataforma com o histórico de serviços de um veículo</li>
      </ul>

      <h2 style={S.h2}>2. Sobre a Plataforma</h2>
      <p style={S.p}>O NICO é uma plataforma de gestão de manutenção veicular que permite aos donos de veículos registrar, organizar e compartilhar o histórico de serviços. O diferencial da plataforma é a validação de serviços por profissionais credenciados, criando um histórico verificado e confiável.</p>

      <h2 style={S.h2}>3. Cadastro e Conta</h2>
      <ul style={S.ul}>
        <li style={S.li}>Você deve ter pelo menos 18 anos para utilizar a plataforma</li>
        <li style={S.li}>Os dados informados devem ser verdadeiros, completos e atualizados</li>
        <li style={S.li}>Cada pessoa pode ter apenas uma conta ativa</li>
        <li style={S.li}>Você é responsável por manter a confidencialidade da sua senha</li>
        <li style={S.li}>A Lab2513 pode suspender ou encerrar contas que violem estes termos</li>
      </ul>

      <h2 style={S.h2}>4. Contas Gratuitas e Pagas</h2>
      <h3 style={S.h3}>4.1 Conta Dono (gratuita)</h3>
      <ul style={S.ul}>
        <li style={S.li}>Cadastro de até 3 veículos</li>
        <li style={S.li}>Registro ilimitado de serviços</li>
        <li style={S.li}>Alertas de manutenção</li>
        <li style={S.li}>Geração de relatórios</li>
      </ul>

      <h3 style={S.h3}>4.2 Conta Profissional Grátis</h3>
      <ul style={S.ul}>
        <li style={S.li}>Perfil público básico</li>
        <li style={S.li}>Até 10 validações por mês</li>
        <li style={S.li}>Aparecer nas buscas</li>
      </ul>

      <h3 style={S.h3}>4.3 Conta Profissional Pro (R$ 99/mês)</h3>
      <ul style={S.ul}>
        <li style={S.li}>Validações ilimitadas</li>
        <li style={S.li}>CRM de clientes</li>
        <li style={S.li}>Selo verificado NICO</li>
        <li style={S.li}>Destaque nas buscas</li>
        <li style={S.li}>Responder avaliações</li>
      </ul>
      <p style={S.p}>A Lab2513 reserva-se o direito de alterar preços e funcionalidades dos planos mediante aviso prévio de 30 dias.</p>

      <h2 style={S.h2}>5. Uso Aceitável</h2>
      <p style={S.p}>Ao utilizar a plataforma, você se compromete a:</p>
      <ul style={S.ul}>
        <li style={S.li}>Registrar informações verdadeiras e precisas sobre serviços e veículos</li>
        <li style={S.li}>Não falsificar validações ou se passar por profissional sem sê-lo</li>
        <li style={S.li}>Não utilizar a plataforma para fins ilícitos ou fraudulentos</li>
        <li style={S.li}>Não tentar acessar contas de outros usuários ou sistemas da plataforma</li>
        <li style={S.li}>Não utilizar bots, scrapers ou ferramentas automatizadas sem autorização</li>
      </ul>

      <h2 style={S.h2}>6. Validação de Serviços</h2>
      <div style={S.highlight}>
        <p style={{ ...S.p, margin: 0 }}><strong>Importante:</strong> a validação profissional atesta que o serviço foi realizado conforme declarado. A Lab2513 não realiza, supervisiona nem garante a qualidade dos serviços mecânicos em si. A plataforma é um meio de registro e verificação, não uma garantia sobre o serviço prestado.</p>
      </div>
      <ul style={S.ul}>
        <li style={S.li}>O Profissional é responsável pela veracidade das validações que realiza</li>
        <li style={S.li}>Validações fraudulentas podem resultar em suspensão permanente da conta e responsabilização civil</li>
        <li style={S.li}>O Dono pode contestar validações que considere incorretas</li>
      </ul>

      <h2 style={S.h2}>7. Relatórios de Venda</h2>
      <ul style={S.ul}>
        <li style={S.li}>Os relatórios gerados pela plataforma refletem os dados registrados e validados pelos usuários</li>
        <li style={S.li}>A Lab2513 não garante a completude do histórico — apenas registra o que foi informado</li>
        <li style={S.li}>O relatório não substitui vistorias técnicas, laudos cautelares ou inspeções veiculares obrigatórias</li>
        <li style={S.li}>A Lab2513 não se responsabiliza por decisões de compra ou venda baseadas exclusivamente no relatório</li>
      </ul>

      <h2 style={S.h2}>8. Propriedade Intelectual</h2>
      <p style={S.p}>A marca NICO, o logotipo, o mascote, o design da plataforma, os textos, códigos e demais elementos são de propriedade da Lab2513 Tecnologia e estão protegidos pela legislação de propriedade intelectual. Você não pode copiar, reproduzir, distribuir ou criar obras derivadas sem autorização prévia e escrita.</p>

      <h2 style={S.h2}>9. Limitação de Responsabilidade</h2>
      <ul style={S.ul}>
        <li style={S.li}>A plataforma é fornecida "como está" (<em>as is</em>), sem garantias de disponibilidade ininterrupta</li>
        <li style={S.li}>A Lab2513 não se responsabiliza por danos diretos ou indiretos decorrentes do uso da plataforma</li>
        <li style={S.li}>A Lab2513 não é responsável pela qualidade, segurança ou legalidade dos serviços prestados por Profissionais cadastrados</li>
        <li style={S.li}>A Lab2513 não é parte nas transações entre Donos e Profissionais</li>
        <li style={S.li}>Em nenhuma hipótese a responsabilidade total da Lab2513 excederá o valor pago pelo usuário nos últimos 12 meses</li>
      </ul>

      <h2 style={S.h2}>10. Indenização</h2>
      <p style={S.p}>Você concorda em indenizar e isentar a Lab2513, seus sócios, diretores, funcionários e prestadores de serviço de qualquer reclamação, perda, dano ou despesa (incluindo honorários advocatícios) decorrente do uso indevido da plataforma ou violação destes termos.</p>

      <h2 style={S.h2}>11. Encerramento</h2>
      <ul style={S.ul}>
        <li style={S.li}>Você pode encerrar sua conta a qualquer momento através das configurações do perfil ou por e-mail</li>
        <li style={S.li}>A Lab2513 pode encerrar ou suspender contas que violem estes termos, sem aviso prévio em casos graves</li>
        <li style={S.li}>Após o encerramento, seus dados serão tratados conforme a Política de Privacidade</li>
      </ul>

      <h2 style={S.h2}>12. Alterações nos Termos</h2>
      <p style={S.p}>Estes termos podem ser atualizados a qualquer momento. Alterações significativas serão comunicadas com antecedência mínima de 30 dias. O uso continuado da plataforma após as alterações constitui aceitação dos novos termos.</p>

      <h2 style={S.h2}>13. Legislação Aplicável e Foro</h2>
      <p style={S.p}>Estes Termos são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da Comarca do Rio de Janeiro/RJ para dirimir quaisquer controvérsias, com renúncia a qualquer outro, por mais privilegiado que seja.</p>

      <h2 style={S.h2}>14. Contato</h2>
      <ul style={S.ul}>
        <li style={S.li}><strong>Lab2513 Tecnologia</strong></li>
        <li style={S.li}><strong>E-mail:</strong> contato@usenico.com.br</li>
        <li style={S.li}><strong>Plataforma:</strong> usenico.com.br</li>
      </ul>
    </PageWrapper>
  );
}
